import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { Store } from '@ngrx/store';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { NomWebServicesJson } from '@src/suite/common/services/nom-web-services-json';
import { VisualStateService } from '@src/suite/common/services/visual-state-service';
import { CreateViewStateActions } from '@src/suite/common/store/createviewstate/createviewstate.actions';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';

@Component({
    selector: 'st-planning-views-main-cta',
    imports: [MatButtonToggleModule, MatIconModule, MatListModule, MatMenuModule],
    templateUrl: './planning-view-main-cta.component.html',
    styleUrl: './planning-view-main-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-planning-views-main-cta',
    },
})
export class PlanningViewsMainCtaComponent {
    visualStateService = inject(VisualStateService);
    store = inject(Store);
    globalTablesService = inject(GlobalTablesService);
    nomWebServicesJson = inject(NomWebServicesJson);

    readonly languageSettings = this.store.selectSignal(selectI18N)();

    public createViewState() {
        this.store.dispatch(CreateViewStateActions.createUpdateViewState({ copy: false, edit: false }));
    }
}
